import React from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { TextareaAutosizeElement } from 'react-hook-form-mui';
import GenericModalForm from '../GenericModalForm';
import ar from './ar.json';
import en from './en.json';
import { LocaleContext } from '../../../../contexts/language';
import { IntlProvider } from 'react-intl';
import BasicEnquiryFormFields from '../../../atoms/BasicEnquiryFormFields';
import PropTypes from 'prop-types';

const languages = {
  ar,
  en
};


export const ContactDealerForm = ({ ...rest }) => {

  const localeConfig = React.useContext(LocaleContext);


  return (
    <IntlProvider locale={localeConfig?.lang} messages={languages[localeConfig?.lang] || languages.en}>
      <GenericModalForm
        {...rest}
        defaultValues={{
          ...rest,
          firstName: '',
          lastName: '',
          message: 'Hi,' +
            '' +
            'I\'m interested in this vehicle. Can you send me a quote, and contact me to discuss the purchase options available?',
          emailAddress: '',
          phoneNumber: ''
        }}
        // editTitle={'Edit Person'}
        addTitle={'Send an Enquiry'}
        editTitle={'Send an Enquiry'}
        onSubmitText={'Send Enquiry'}
        onSubmitTitle={'Ask a question'}
        onNewSnackText={'Enquiry Sent successfully'}
        onEditSnackText={'Enquiry Sent successfully'}>
        {({ loading }) => (
          <>
            <BasicEnquiryFormFields loading={loading} />
            <Grid xs={12}>
              <TextareaAutosizeElement
                disabled={loading}
                fullWidth
                minRows={3}
                name={'message'}
                required
                label={'Message'}
                // helperText={'Please provide a brief description of your business'}
                validation={{
                  minLength: { value: 1, message: 'Value is too short' },
                  maxLength: { value: 4000, message: 'Value is too long' },
                  required: 'This field is required'
                  // pattern: {value: /^[A-Za-z]+$/i, message: 'The value is invalid, only a single word is allowed'},
                }}

              />
            </Grid>
          </>
        )}
      </GenericModalForm>
    </IntlProvider>
  );
};

ContactDealerForm.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};
ContactDealerForm.defaultProps = {
  onClose: () => {
  },
  open: false
};

export default ContactDealerForm;